import { render, staticRenderFns } from "./help-dialog.vue?vue&type=template&id=63a95ca6"
import script from "./help-dialog.vue?vue&type=script&lang=js"
export * from "./help-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports